import React from 'react';
import ServiceWork from "../../../components/pages/form/ServiceWork/ServiceWork";

const ServiceWorkPage = () => {
    return <ServiceWork />;
};

export default ServiceWorkPage;
